<template>
  <tr>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-select
        v-model="searchData.jenis_promo"
        :items="jenisPromoList"
        label="Jenis Promo"
        item-text="text"
        item-value="value"
        @change="getData"
        clearable
        hide-details="true"
        dense
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-dialog
        ref="dateStartPopup"
        v-model="dateStartPopup"
        :return-value.sync="searchData.start_datetime"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            id="dateRangeText"
            readonly
            v-bind="attrs"
            v-on="on"
            v-model="dateRangeText"
            label="Start Date"
            hide-details="true"
            dense
            clearable
            @click:clear="clearStartDate"
          />
        </template>
        <v-date-picker v-model="searchData.start_datetime" scrollable range>
          <v-spacer />
          <v-btn text color="primary" @click="dateStartPopup = false">
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="
              () => {
                checkRangeDate(searchData.start_datetime);
                $refs.dateStartPopup.save(searchData.start_datetime);
                getData();
              }
            "
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-dialog
        ref="dateEndPopup"
        v-model="dateEndPopup"
        :return-value.sync="searchData.end_datetime"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            id="endDateRangeText"
            readonly
            v-bind="attrs"
            v-on="on"
            v-model="endDateRangeText"
            label="End Date"
            hide-details="true"
            dense
            clearable
            @click:clear="clearEndDate"
          />
        </template>
        <v-date-picker v-model="searchData.end_datetime" scrollable range>
          <v-spacer />
          <v-btn text color="primary" @click="dateEndPopup = false">
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="
              () => {
                checkRangeDate(searchData.end_datetime);
                $refs.dateEndPopup.save(searchData.end_datetime);
                getData();
              }
            "
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </td>

    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-select
        v-model="searchData.status"
        :items="listPromoStatus"
        label="Status"
        item-text="text"
        item-value="value"
        @change="getData"
        clearable
        hide-details="true"
        dense
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
  </tr>
</template>

<script>
import { dataJenisPromoList, dataListPromoStatus } from '../../store/params';

export default {
  props: ['search'],
  data: () => ({
    startDatetime: '',
    dateStartPopup: false,
    endDatetime: '',
    dateEndPopup: false,
    jenisPromoList: dataJenisPromoList,
    searchIssuer: '',
    listPromoStatus: dataListPromoStatus,
  }),

  computed: {
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
    dateRangeText() {
      return this.searchData.start_datetime.join(' ~ ');
    },
    endDateRangeText() {
      return this.searchData.end_datetime.join(' ~ ');
    },
  },
  methods: {
    checkRangeDate(date) {
      date.sort();
      if (date.length == 1) {
        date.push(date[0]);
      }
    },
    getData() {
      this.$emit('getDataParent');
    },
    clearStartDate() {
      this.searchData.start_datetime = [];
      this.getData();
    },
    clearEndDate() {
      this.searchData.end_datetime = [];
      this.getData();
    },
  },
};
</script>
